import React from "react";
import ClientCustomerHome from "pages/ClientCustomerHome";
import Icon from "@mui/material/Icon";

export type ClientRoute = {
  type: string;
  name: string;
  key: string;
  icon: React.ReactNode;
  route: string;
  component: React.ReactElement;
  noCollapse?: boolean;
  alwaysAccessible?: boolean;
  protected?: boolean;
  onClick?: () => void;
};

export const clientRoutes: ClientRoute[] = [
  {
    type: "collapse",
    name: "My Account",
    key: "my-account",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <ClientCustomerHome />,
    noCollapse: true,
    alwaysAccessible: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/logout",
    component: <></>,
    noCollapse: true,
    alwaysAccessible: true,
  },
];

export default clientRoutes;
